import React from "react";
import { AuthTemplate } from "@components/templates";
import { useUserInfo } from "@store/hooks";
import { AuthPageProps } from "@utils/Constants";

const AuthPage = () => {
  const userInfo = useUserInfo();

  const props = AuthPageProps[userInfo.authType!];

  return <AuthTemplate {...props} />;
};

export default AuthPage;
